export const getClaimFormCompletionInfo = (reclamation) => {
  const hasCustomerInfo = Boolean(
    String(reclamation.customerName || '').trim() &&
      String(reclamation.customerEmail || '').trim() &&
      String(reclamation.customerPhone || '').trim()
  );
  const vehicle = reclamation.vehicleDetails || {};
  const hasVehicleInfo = Boolean(
    String(vehicle.make || '').trim() &&
      String(vehicle.model || '').trim() &&
      String(vehicle.year || '').trim() &&
      String(vehicle.color || '').trim() &&
      (String(vehicle.vin || '').trim() || String(vehicle.plate || '').trim())
  );

  return {
    hasRequiredClaimInfo: hasCustomerInfo && hasVehicleInfo,
  };
};
